import { render } from "./AboutBreakdown.vue?vue&type=template&id=1d3d4b58&scoped=true"
import script from "./AboutBreakdown.vue?vue&type=script&lang=js"
export * from "./AboutBreakdown.vue?vue&type=script&lang=js"

import "./AboutBreakdown.vue?vue&type=style&index=0&id=1d3d4b58&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d3d4b58"

export default script